import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';
import { TabPanel } from '@chakra-ui/react';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px 1.875rem;
  transition: all 0.5s ease-out;

  @media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
`;

export const Header = styled.header`
  padding: 20px 10px 10px;

  h1 {
    font-size: 1.6rem;
    font-weight: 600;
  };

	h2 {
		font-weight: 500;
	};

	// 479px
  @media (max-width: 29.9375rem) {
		h2 {
			font-size: 1.2rem;
			font-weight: 500;
		};
	}
`;

export const TabsView = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  // border: 2px solid blue;

  .tabs {
    width: 100%;

    .tab-list {
      .tab {
				font-size: 1.2rem;
        font-weight: 600;

        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        }
      }
    }

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;
      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        padding: 0;
      }
    }
  }
`;

export const TabProduto = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
`;

export const FormViewDetalhes = styled(Form)`
  display: flex;
  width: 100%;
  padding: 5px 0;
  margin-bottom: 60px;

  div.form-left {
    display: flex;
    flex-direction: column;
    width: 100%;

    div.input {
      display: flex;
      flex-direction: column;

      p {
        font-size: 1rem;
        font-weight: 500;
        margin: 15px 0 3px;

        span {
          font-size: 0.8rem;
          color: #455a64;
        }
      }

      span {
        font-size: 0.8rem;
        font-weight: 500;
        color: #455a64;
        text-align: end;
        width: 100%;
        padding: 5px 10px 0 0;
      }
    }
  }
  div.form-right {
    display: flex;
    flex-direction: column;
    width: 70%;
    padding: 10px;
		// border: 2px solid blue;

    p {
      font-size: 1rem;
      font-weight: 500;
    }

    span {
      font-size: 0.8rem;
      font-weight: 500;
      margin-bottom: 10px;
    }

    div.dados-imagem {
      display: flex;
      margin: 0 0 -10px;
      padding: 0 0 -10px;

      span {
        font-size: 0.8rem;
        font-weight: 400;
        margin: 0;
        padding: 0;
      }
      p {
        font-size: 0.8rem;
        font-weight: 600;
        margin: 0;
        padding: 0;
      }
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		flex-direction: column-reverse;

		div.form-right {
			width: 100%;
			justify-content: center;
			align-items: center;
		}
	}
`;

export const ImgInput = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 250px;
  height: 180px;
  border: 3px solid var(--gray-border-lg);
  border-style: dashed;
  border-radius: 10px;
  margin-bottom: 10px;

  img {
    display: flex;
    width: auto;
    height: auto;
    max-width: 240px;
    max-height: 170px;
    border-radius: 10px;
  }

  label {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    border-radius: 50%;
    border: 0;
    cursor: pointer;
    transition: background-color 0.2s;

    input {
      display: none;
    }

    svg {
      width: 25px;
      height: 25px;
      color: #312e38;
    }

    &:hover {
      filter: brightness(0.9);
    }
  }

  label.select-picture {
    width: 45px;
    height: 45px;
    background: var(--azul-razio);
    right: -12px;
    bottom: -12px;

    svg {
      color: #fff;
    }
  }
  label.remove-picture {
    width: 30px;
    height: 30px;
    background: var(--gray-border-md);
    top: -10px;
    right: -10px;

    svg {
      width: 20px;
      height: 20px;
      color: #312e38;
    }
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 700px;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 10px 20px;
    margin: 5px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const TabComplemento = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 100%;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
  }
`;

export const SelectedYesNo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 40px 30px 40px;
  background-color: #eceff1;
  border-radius: 8px;
  width: 100%;
  margin-top: 10px;

  h1 {
    font-size: 1.4rem;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .radio-group {
    .radio {
      .radio-label {
        display: flex;
        align-items: center;

        :last-child {
          margin-top: 10px;
        }

        input[type='radio'] {
          margin-right: 10px;
          appearance: none;
          font: inherit;
          color: var(--azul-razio);
          width: 18px;
          height: 18px;
          border: 2px solid var(--gray-border-lw);
          border-radius: 50%;

          :checked {
            border: 5px solid var(--azul-razio);
          }
        }

        label {
          font-size: 17px;
        }
      }
    }
  };

	// 479px
  @media (max-width: 29.9375rem) {
		padding: 20px 20px 30px;

		.radio-group {
			.radio {
				.radio-label {
					input[type='radio'] {
						width: 21px;
						height: 18px;
						border: 5px solid var(--gray-border-lw);

						:checked {
							border: 5px solid var(--azul-razio);
						}
					}

					label {
						font-size: 1.1rem;
						font-weight: 500;
					}
				}
			}
		}
	}
`;

export const ButtonsComp = styled.div`
  display: flex;

  button {
    background-color: #fff;
    border: 2px solid var(--azul-razio);
    color: var(--azul-razio);
    border-radius: 8px;
    padding: 10px 20px;
    margin: 10px;
    font-size: 0.9rem;
    font-weight: 600;
  }
`;

export const GruposList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 20px;
  list-style: none;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px 2px 10px 2px;
  padding: 15px 10px;

  header {
    font-weight: 500;
    margin: 0;
    padding: 0;
  }
`;

export const Grupo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  width: 100%;

  .accordion {
    .accordion-item {
      border-bottom: 0;
      margin: 0 20px;

      .accordion-button {
        border-radius: 4px;
        margin: 0 5px;
        padding: 5px;

        svg {
          font-size: 1.7rem;
          color: var(--azul-razio);
        }
      }
      .header-grupo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0 10px 0;

        div.name-grupo {
          h1 {
            font-size: 1.1rem;
            font-weight: 500;
          }
          h2 {
            font-size: 0.9rem;
            font-weight: 500;
          }
        }

        span {
          font-size: 0.8rem;
          font-weight: 500;
          background-color: var(--gray-border-md);
          padding: 3px 10px;
          border-radius: 4px;
          text-transform: uppercase;
        }
      }
      .buttons-grupo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        //width: 100%;

        .menu-button {
          margin: 0 5px;
          border: 0;

          svg {
            font-size: 25px;
            padding: 0;
          }
        }
      }

      .accordion-panel {
        width: 100%;
        padding: 0;
        margin: 0;
      }
    }
  }
`;

export const ComplementosList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  // grid-gap: 10px;
  list-style: none;
  position: relative;
  height: 100%;
  padding: 20px 0;
`;

export const Complemento = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid var(--gray-border-lw);

  :first-child {
    border-top: 0;
  }

  div.name-description {
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 1.1rem;
      font-weight: 500;
    }
    h2 {
      font-size: 0.9rem;
      color: #546e7a;
      font-weight: 500;
    }
    h3 {
      font-size: 0.9rem;
      font-weight: 500;
    }
  }

  h2 {
    font-size: 1.1rem;
    font-weight: 600;
    margin-left: 15px;
  }
`;

export const AddGrupoComplementos = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--gray-border-lw);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  margin-top: 20px;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid var(--gray-border-lw);

    h1 {
      font-size: 1.2rem;
      font-weight: 500;
    }

    button {
      border: 1px solid var(--red-razio);
      color: var(--red-razio);
      padding: 5px 10px;
      border-radius: 10px;
    }
  }
`;

export const FormViewGrupoComp = styled(Form)`
  display: flex;
  align-items: flex-end;
  padding: 0 20px 20px;

  div.input {
    display: flex;
    flex-direction: column;
    width: 100%;

    p {
      font-size: 1rem;
      font-weight: 600;
      margin: 15px 0 3px;

      span {
        font-size: 0.8rem;
        font-weight: 500;
        color: #455a64;
      }
    }

    span.span-p {
      font-size: 0.8rem;
      font-weight: 500;
      color: #455a64;
      margin-bottom: 5px;
    }

    div.pesquisa-produto {
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: 127px; //calc(100% + 230px);
      background-color: #fff;
      border: 1px solid var(--gray-border-lg);
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
      border-bottom: none;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      width: 470px;
      height: auto;
      max-height: 150px;
      overflow-y: scroll;
      // transition: opacity 0.4s;
      // transform: translateX(-50%);

      div.pesquisa-item {
        cursor: pointer;

        &:hover {
          filter: brightness(0.9);
          background-color: #eceff1;
        }

        span {
          padding: 10px;
        }
      }
    }
  }

  button.button-confirm {
    background-color: var(--azul-razio);
    padding: 7px 20px;
    border-radius: 8px;
    color: #fff;
    margin: 0 10px;
  }
`;
